<template>
    <div class="w-full">
        <dropdown
            ref="classroomSelectDropdown"
            open-from="left"
            :px-width="320"
        >
            <template #button>
                <div class="w-auto rounded border border-gray-450 p-2">
                    <text-clamp
                        autoResize
                        :max-lines="1"
                        :text="selectedClassroomName"
                    ></text-clamp>
                </div>
            </template>
            <template #content>
                <div class="rounded border p-1 text-[15px]">
                    <ul class="max-h-40 overflow-y-scroll">
                        <li
                            v-for="classroomOption in [
                                { label: '-- No Classroom', value: null },
                                ...classroomOptions,
                            ]"
                            @click="selectClassroom(classroomOption.value)"
                            class="group flex-col gap-3 rounded p-3 hover:cursor-pointer hover:bg-primary-500 hover:text-white"
                        >
                            <div class="">{{ classroomOption.label }}</div>
                        </li>
                    </ul>
                </div>
            </template>
        </dropdown>
    </div>
</template>
<script>
import Dropdown from "@/Components/Dropdown.vue";
import FormInput from "@/Components/FormInput.vue";
import FormSelect from "@/Components/FormSelect.vue";

export default {
    name: "GroupStudentClassroomSelect",
    components: { FormInput, FormSelect, Dropdown },
    props: {
        modelValue: {},
        classroomOptions: {},
    },
    data() {
        return {
            selectedClassroomId: this.modelValue,
            form: this.$inertia.form({
                classroomName: "",
                ownerId: "",
            }),
        };
    },
    methods: {
        selectClassroom(classroomId) {
            this.$emit("update:modelValue", classroomId);
            this.$refs.classroomSelectDropdown.closeDropdown();
        },
    },
    computed: {
        selectedClassroomName() {
            let vm = this;
            let selectedOption;

            selectedOption = _.filter(vm.classroomOptions, function (option) {
                return option.value === vm.modelValue;
            })[0];

            return selectedOption ? selectedOption.label : "--";
        },
    },
};
</script>
